import React from 'react';
import ReviewOutlinedSVG from 'src/assets/svg/review-outlined.svg';
import { Base, Button } from 'src/components';
import { Flyout } from 'src/componentsTailwind/index';
import CircledIcon from 'src/components/CircledIcon/CircledIcon';

const FiltersFlyout = (props = {}) => {
  const { render = () => {}, apply = () => {}, clear = () => {} } = props;

  const closeFiltersOnClickAway = (e) => {
    const targetClassLists = e?.target?.classList;
    const targetParentClassLists = e?.target?.parentNode?.classList;

    const isClickingOnSelect = targetClassLists?.contains('select-filter')
      || targetParentClassLists?.contains('select-filter')
      || targetClassLists?.contains('select-option')
      || targetParentClassLists?.contains('select-option');

    if (!isClickingOnSelect) {
      const allSelects = document.querySelectorAll('.open-select-filter');
      allSelects.forEach((el) => {
        if (e?.target?.id !== el.id) {
          el.click();
        }
      });
    }
  };

  return (
    <Flyout {...props} showXButton={false}>
      <Base
        classes='h-full w-full items-center flex flex-col items-stretch justify-between'
        relative
        onMouseDown={closeFiltersOnClickAway}
      >
        <div className='mb-10'>
          <div className='flex items-center'>
            <CircledIcon svg={<ReviewOutlinedSVG className='text-purple' />} />
            <h2 className='text-xl font-bold my-auto mt-2 p-0'>Filters</h2>
          </div>
          <div className='border-b border-mid-gray my-3 transform -translate-x-[16px] w-[calc(100%+32px)]' />
          <div className='flex flex-col w-full h-full gap-5 my-5'>
            {render()}
          </div>
        </div>

        <div className='flex flex-row flex-wrap w-full max-w-280 gap-4 h-9 2xl:h-[39.5px] xl:ml-auto xl:mr-0 justify-center xl:justify-end'>
          <Button
            type='button'
            variant='empty-with-border'
            classes='!rounded-md !text-sm !font-normal py-1 xl:ml-auto xl:mr-0 h-full'
            onClick={clear}
          >
            Clear All
          </Button>
          <Button
            classes='bg-[#0F172A] text-white text-sm     py-1 rounded-md transition-colors duration-300 h-full px-6'
            variant='custom'
            onClick={apply}
          >
            Apply
          </Button>
        </div>
      </Base>
    </Flyout>
  );
};

export default FiltersFlyout;
